import styled from '@emotion/styled';
import { SanitizedStoryPage } from '@lib/pimster-stories/types';
import { getStrapiAssetUrl } from '@lib/strapi';
import { Asset } from '@lib/strapi/utils/getStrapiAssetUrl';
import {
    DetailedHTMLProps,
    forwardRef,
    useMemo,
    VideoHTMLAttributes,
    useRef,
} from 'react';

type VideoElementProps = DetailedHTMLProps<
    VideoHTMLAttributes<HTMLVideoElement>,
    HTMLVideoElement
>;

interface Props extends VideoElementProps {
    storyPage: SanitizedStoryPage;
}

const SVideo = styled.video`
    height: 100%;
    min-width: 100%;
    object-fit: cover;
    object-position: center;
`;

const Video = forwardRef<HTMLVideoElement, Props>(
    ({ storyPage, ...videoProps }, ref) => {
        const internalRef = useRef<HTMLVideoElement>(null);
        const videoRef = ref || internalRef;
        const videoFormats = useMemo(
            () =>
                Object.entries(storyPage.media.formats).reduce(
                    (formats, [key, format]) => {
                        formats[key] = getStrapiAssetUrl(format as Asset) || '';
                        return formats;
                    },
                    {} as { [key: string]: string }
                ),
            [storyPage]
        );

        return (
            <SVideo {...videoProps} ref={videoRef}>
                {/* <source type='video/webm' src={videoFormats['hd_webm']} /> */}
                <source type='video/mp4' src={videoFormats['hd_mp4']} />
                <source
                    type='video/mp4'
                    src={`${process.env.NEXT_PUBLIC_AWS_CF_URL}/${storyPage.media.hash}${storyPage.media.ext}`}
                />
            </SVideo>
        );
    }
);
Video.displayName = 'Video';

export default Video;
